<div class="dashbox_title_flex">
  <h2 class="dashbox_title">Market</h2>
  <div class="primary_inp_grp">
    <input placeholder="Search Pair" type="text" class="primary_inp" (input)="handleSearchPair($event)" />
    <img src="assets/images/search_icon.png" class="img-fluid" alt="Search" />
  </div>
</div>
<ul class="nav nav-pills primary_tab" id="pills-tab" role="tablist">
  <li class="nav-item" role="presentation" *ngFor="let currency of currencies">
    <button class="nav-link" [ngClass]="{ active: currency === activeCurrency }" id="pills-{{ currency }}-tab"
      data-bs-toggle="pill" [attr.data-bs-target]="'#pills-' + currency + '-pair'" type="button" role="tab"
      [attr.aria-controls]="'#pills-' + currency + '-pair'" aria-selected="false">
      {{ currency }}
    </button>
  </li>
</ul>
<div class="tab-content" id="pills-tabContent">
  <div class="tab-pane fade" [ngClass]="{ 'active show': currency === activeCurrency }"
    [id]="'pills-' + currency + '-pair'" role="tabpanel" [attr.aria-labelledby]="'pills-' + currency + '-pair-tab'"
    tabindex="0" *ngFor="let currency of currencies">
    <div class="table-responsive">
      <table class="table primary_table">
        <thead>
          <tr>
            <th (click)="sortData('tikerRoot')"> <i class="fa-solid fa-sort mx-1 cursor-pointer"></i>Pair</th>
            <th (click)="sortData('markPrice')"><i class="fa-solid fa-sort mx-1 cursor-pointer"></i>Price</th>
            <th (click)="sortData('change')"><i class="fa-solid fa-sort mx-1 cursor-pointer"></i>24H Change</th>
            <th (click)="sortData('high')"><i class="fa-solid fa-sort mx-1 cursor-pointer"></i>24H High</th>
            <th (click)="sortData('low')"><i class="fa-solid fa-sort mx-1 cursor-pointer"></i>24H Low</th>
            <th (click)="sortData('firstVolume')"><i class="fa-solid fa-sort mx-1 cursor-pointer"></i>24H Volume</th>
          </tr>
        </thead>
        <tbody>
          <ng-container
            *ngIf="(sortedPairs[currency] | textFilter: 'tikerRoot': searchPair).length > 0; else noRecords">
            <tr
              *ngFor="let pair of sortedPairs[currency] | textFilter: 'tikerRoot': searchPair  | paginate: { itemsPerPage: itemsPerPage, currentPage: currentPage }">
              <td>
                <div class="d-flex align-items-center cursor-pointer">
                  <a class="nav-link" [routerLink]="'/spot/'+pair.firstCurrencySymbol+'_'+pair.secondCurrencySymbol">
                    <img src="{{ getCurrecyImage(pair.firstCurrencySymbol) }}" alt="Crypto"
                      class="img-fluid history_table_icon" />
                    <span>{{ pair.firstCurrencySymbol }} / {{pair .secondCurrencySymbol}}</span>
                  </a>
                </div>
              </td>
              <td>
                <span [title]="truncateDecimals(pair.markPrice, pair.secondFloatDigit)">
                  {{ longDecimals(truncateDecimals(pair.markPrice, pair.secondFloatDigit)) }}
                </span>
              </td>
              <td>
                <span [ngClass]="{'green_txt': pair.change >= 0, 'red_txt': pair.change < 0}">
                  {{ truncateDecimals(pair.change, 3) }}%
                </span>
              </td>
              <td>
                <span [title]="truncateDecimals(pair.high, pair.secondFloatDigit)">
                  {{ longDecimals(truncateDecimals(pair.high, pair.secondFloatDigit)) }}
                </span>
              </td>
              <td>
                <span [title]="truncateDecimals(pair.low, pair.secondFloatDigit)">
                  {{ longDecimals(truncateDecimals(pair.low, pair.secondFloatDigit)) }}
                </span>
              </td>
              <td>
                <span [title]="truncateDecimals(pair.firstVolume, pair.secondFloatDigit)">
                  {{ longDecimals(truncateDecimals(pair.firstVolume, pair.secondFloatDigit)) }}
                </span>
              </td>
            </tr>
          </ng-container>

          <!-- "No Records Found" message when there are no matching sortedPairs -->
          <ng-template #noRecords>
            <tr>
              <td colspan="6">
                <div class="text-center mt-3">
                  <img src="assets/images/no_records_found.png" alt="No Records" class="img-fluid" />
                  <p>Select The correct Pair Name!</p>
                </div>
              </td>
            </tr>
          </ng-template>
        </tbody>


      </table>
      <!-- Pagination Controls -->
      <div class="pagination-container text-center mt-3">
        <pagination-controls (pageChange)="currentPage = $event"></pagination-controls>
      </div>
    </div>
  </div>
</div>  